module.exports = __webpack_public_path__ + "img/setup.560d9cf0.png";